import { Tag, Input, Tooltip, Icon, message} from 'antd';
import React from 'react';
import {uuid} from '../../util/index';
import Sortable from 'sortablejs';

export default class EditableTagGroup extends React.Component {
  state = {
    tags: [],
    inputVisible: false,
    inputValue: '',
  };

  componentDidMount() {
    let {value} = this.props;

    this.setState({
      tags:value || [],
      uuid:uuid()
    }, this.initSortable);
  }

  initSortable = ()=>{
    new Sortable(document.querySelector(`#movetag_${this.state.uuid}`), {
      animation:150,
      ghostClass:"movetag-list-item-ghost",
      onEnd:(opt)=>{
        let {oldIndex, newIndex} = opt;
        if(oldIndex == newIndex) {
          return;
        }
        this.onSortEnd({
          newIndex:newIndex + 1,
          oldIndex:oldIndex
        });
      }
    });
  }

  componentWillReceiveProps(nextProps) {
    let {value} = nextProps;

    this.setState({
      tags:value || []
    });
  }

  onSortEnd = (opt)=>{
    let {tags} = this.state;
    let {newIndex, oldIndex} = opt;
    console.log(newIndex, oldIndex);

    let target = tags[oldIndex] + "";
    if(newIndex > oldIndex) {
      tags.splice(newIndex, 0, target);
      tags.splice(oldIndex, 1);
    }
    if(newIndex < oldIndex) {
      tags.splice(oldIndex, 1);
      tags.splice(newIndex - 1, 0, target);
    }

    console.log(tags);

    this.setState({
      tags
    }, this.onChange);
  }

  onChange = ()=>{
    if(this.props.onChange) {
      this.props.onChange(this.state.tags);
    }
  }

  doClose = (removedTag)=>{
    const tags = this.state.tags.filter(tag => tag !== removedTag);
    this.setState({ tags }, this.onChange);
  }

  handleClose = removedTag => {
    let {onRemove} = this.props;
    if(onRemove) {
      return (new Promise((resolve, reject)=>{
        onRemove(removedTag, resolve, reject);
      })).then(res=>{
        this.doClose(removedTag);
      })
    }else {
      this.doClose(removedTag);
    }
  };

  showInput = () => {
    this.setState({ inputVisible: true }, () => this.input.focus());
  };

  handleInputChange = e => {
    // 20201207 替换几个特殊符号，否则会引起前端传参异常
    let value = e.target.value || "";
    // /^[^+][^\/:*?"<>|]*$/
    if(value.match(/[&,\/:*?"<>|+]/ig)) {
      return message.warn('标签内容，禁止包含特殊符号：& , \\ / : * ? " < > | +等');
    }
    this.setState({ inputValue: (value).replace(/[&,\/:*?"<>|+]/ig, '') });
  };

  handleInputConfirm = () => {
    const { inputValue } = this.state;
    let { tags } = this.state;
    if (inputValue && tags.indexOf(inputValue) === -1) {
      tags = [...tags, inputValue];
    }
    this.setState({
      tags,
      inputVisible: false,
      inputValue: '',
    }, this.onChange);
  };

  saveInputRef = input => (this.input = input);

  render() {
    const { tags, inputVisible, inputValue } = this.state;
    const {staticTag = [], tip} = this.props;
    return (
      <div style={{lineHeight:'28px'}}>
        {staticTag.map(tag=>{
          return <Tag key={tag}>{tag}</Tag>;
        })}
        <div className="movetag-list">
          <div id={`movetag_${this.state.uuid}`}>
          {tags.map((tag, index) => {
            const isLongTag = tag.length > 20;
            const tagElem = (
              <Tag key={tag} closable={true} onClose={() => this.handleClose(tag)}>
                {isLongTag ? `${tag.slice(0, 20)}...` : tag}
              </Tag>
            );
            return isLongTag ? (
              <Tooltip title={tag} key={tag}>
                {tagElem}
              </Tooltip>
            ) : (
              tagElem
            );
          })}
          </div>
          {inputVisible && (
            <Input
              ref={this.saveInputRef}
              type="text"
              size="small"
              style={{ width: 78, display:'inline-block' }}
              value={inputValue}
              onChange={this.handleInputChange}
              onBlur={this.handleInputConfirm}
              onPressEnter={this.handleInputConfirm}
            />
          )}
          {!inputVisible && (
            <Tag onClick={this.showInput} style={{ display:'inline-block', background: '#fff', borderStyle: 'dashed' }}>
              <Icon type="plus" /> 新增标签
            </Tag>
          )}
          {tip ? <div style={{color:'#f5222d'}}>{tip}</div> : null}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Select/MoveTag.js